var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video_source)?_c('video-bg',{attrs:{"sources":[_vm.mobile_view?_vm.video_source_mobile:_vm.video_source]}},[_c('Header',{on:{"refresh":_vm.refresh}})],1):_c('Header',{on:{"refresh":_vm.refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }